/* eslint-disable camelcase */
import moment from 'moment'
import memoize from 'memoizerific'

import { checkDate } from "../app/timetable/timetable"
import { getText } from '../app/lib/text.js'

/**
 * warnings on a route's contents
 */

// Esto detecta:
function _getWarningsItem(item, i, agenda, activities, date, routeDays) {
  const warnings = []
  const fi = routeDays.indexOf(item)
  
  // Días
  if (item.type === "day") {
    // días vacíos (día seguido de día, o último item)
    if (agenda.length === (i + 1) || (agenda[i + 1] && agenda[i + 1].type === "day")) {
      warnings.push(getText("Día vacío"))
    }
  }

  // Actividades
  if (item.type == "activity" && activities) {
    const a = activities[item.id]
    
    if (a.unknownAvailability && !a.alwaysOpen) {
      warnings.push("No se sabe disponibilidad")
    }
    else if (!a.alwaysOpen) {
      const tt = a.timetable    
      const check = checkDate(tt, date)
      
      // closed day
      if (!check.open) {
        warnings.push(`Cierra este dia`)
      }
      
      // selected time is inside valid rangerange
      else if (item.time && tt.allDay) {
        const ranges = check.allDayTimes
        const itsIn = ranges.some(range => (range.start < item.time && item.time < range.end))
        if (!itsIn) warnings.push(`Parece fuera de horario, (${ranges.map(r => r.start + "-" + r.end).join(", ")})`)
      }
      
      // selected turn is a valid turn
      else if (item.time && !tt.allDay) {
        const itsIn = check.times.includes(item.time)
        if (!itsIn) warnings.push(`No parece un turno válido (${check.times.join(", ")})`)
      }
    }
    
    // actividades sin viaje previo (ciudad precedida de otras ciudades)
    if ((fi > 0 && routeDays[fi - 1].city != item.city) || (fi == 0)) {
      warnings.push(`Falta viaje a ${item.city}`)
    }
  }

  return ((warnings.length == 0) ? null : warnings)
}

const getWarningsItem = memoize(150)(_getWarningsItem)

// #TODO check expenses too!

const _getRouteWarnings = memoize(5)(
  ({ agenda, expenses }, activities, startDate) => {
    let daysCounter = 0
    let date = moment(startDate)
    const routeDays = agenda.filter(x => x.type != "day" && x.city)

    return agenda.map((item, i) => {
      if (item.type === "day") { 
        ++daysCounter 
        date = moment(startDate).add(daysCounter - 1, "days")
      }
      
      return getWarningsItem(item, i, agenda, activities, date, routeDays)
    }) 
  }
)

// we need to force the arity for memoization
const getRouteWarnings = (route, activities, startDate) => (
  _getRouteWarnings(route, activities || null, startDate || null)
)

export default getRouteWarnings
